import React, { useEffect } from 'react';
import { X } from 'lucide-react';
    
const Modal = ({ isOpen, onClose, title, children, footer, size = 'md', preventBackdropClose = false }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };

  return (
    <div className="fixed inset-0 z-50 animate-fadeIn backdrop-blur-sm bg-slate-900/40">
      <div className="flex items-center justify-center min-h-screen px-4 p-4 md:p-8">
        <div 
          className="fixed inset-0 transition-opacity"
          onClick={preventBackdropClose ? undefined : onClose}
        ></div>

        <div className={`relative w-full ${sizeClasses[size]} text-left transition-all transform bg-white shadow-2xl rounded-[2.5rem] animate-slideInUp flex flex-col max-h-[90vh] premium-shadow overflow-hidden`}>
          {/* Premium Header */}
          <div className="flex items-center justify-between p-8 border-b border-slate-100 flex-shrink-0 primary-gradient-bg">
            <h3 className="text-2xl font-black text-white tracking-tight">{title}</h3>
            <button
              onClick={onClose}
              className="p-2.5 bg-white/10 hover:bg-white/20 text-white transition-all duration-300 rounded-xl hover:rotate-90"
            >
              <X size={20} />
            </button>
          </div>
          
          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto px-10 py-8 bg-white">
            {children}
          </div>

          {/* Fixed Footer */}
          {footer && (
            <div className="flex-shrink-0 border-t border-slate-100 p-8 bg-slate-50/50">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>

  );
};

export default Modal;